module.exports = __webpack_public_path__ + "static/media/box-open.c47f08cc.svg";